import Badge from "../../components/badges/Badges";
import { InfoBoard } from "../../components/infoBoard/InfoBoard";
import { PhoneContact } from "../../model/PhoneContact"
import { convertDateTimeToString } from "../../utility/ConvertUtily";

export type ContactInformationRefProps = {
  phoneContact?: PhoneContact;
};

export const ContactInformationRef = ({
    phoneContact= {
      id: "",
      enableFlag: false,
      phoneNo: "000-0000-0000",
      staffName: "担当太郎",
      dayOfWeek: ["0", "0", "0", "0", "0", "0", "0", "0"],
      onCallStartTime: "00:00",
      onCallEndTime: "00:00",
      createUser: "example@example.com",
      createAt: new Date("2000-01-01")
    },
  }
  : ContactInformationRefProps) => {
  const dayOfWeek = ['月','火','水','木','金','土','日','祝日'].map((day, index) => {
    return phoneContact.dayOfWeek[index] === "1"
      ? (<Badge key={`${index}-${day}`} color="green" children={day}/>)
      : (<Badge key={`${index}-${day}`} color="disabled" children={day}/>);
  })
  const file: {[key: string]: any} = {
    '問い合わせボタン表示状態': phoneContact.enableFlag
      ? (<Badge color="green" children={'表示'}/>)
      : (<Badge color="red" children={'非表示'}/>),
    'お問い合わせ電話番号': phoneContact.phoneNo,
    'お問い合わせ担当者名': phoneContact.staffName,
    '発信可能曜日': (<>{dayOfWeek}</>),
    '発信可能時刻': (<>開始 {phoneContact.onCallStartTime} ~ 終了 {phoneContact.onCallEndTime}</>),
    '': (<></>),
    '登録日時': convertDateTimeToString(phoneContact.createAt),
    '更新日時': phoneContact.updateAt !== undefined ? convertDateTimeToString(phoneContact.updateAt) : ''
  };

  return (
    <>
      <InfoBoard col={"col2"} filed={file} children={undefined} />
    </>
  );
};